const themeHashes = {
  dark: ["#only-light", "#gh-light-mode-only"],
  light: ["#only-dark", "#gh-dark-mode-only"]
};
var palette = ({ theme }) => `
/*==================  Palette  ==================*/
/*
  When color palette toggle is enabled in material theme for Mkdocs, there is a possibility to show conditionally 
  images by adding #only-dark or #only-light to resource hash. Backstage doesn't use mkdocs color palette mechanism,
  so there is a need to add css rules from palette*.css manually.
*/

${themeHashes[theme.palette.type].map((hash) => `img[src$="${hash}"]`).join(", ")} {
  display: none;
}
`;

export { palette as default };
//# sourceMappingURL=palette.esm.js.map
